<template>
    <div class="xiangmu">
        <div class="leaderBox" v-if="showOrhide">
		<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/pop/step1.jpg" class="steps step1" v-if="status==1">
			<img src="../../assets/images/pop/step2.jpg" class="steps step2" v-if="status==2">
			<img src="../../assets/images/pop/step3.jpg" class="steps step3" v-if="status==3">
         <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"下一步":status==3?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item>价格管理</el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="产品型号">
						    <el-input v-model="q.materialDescrition" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="产品编号">
						    <el-input v-model="q.materialCode" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="产品大类">
						    <brselectlazy category="product_level" :v="q.hid" v-model="q.hid" :clearable="true"
								style="width:100%"/>
						</el-form-item>
            <el-form-item label="产地" prop="factory">
              <brselect category="factory" :v="q.chandidata" :showcode="true"
                        v-model="q.chandidata" :multiple="true" :collapse-tags="true" clearable></brselect>
            </el-form-item>
						<!--<el-form-item label="定价状态">
						    <el-select v-model="q.setprice" placeholder="请选择" style="width:100%;">
						        <el-option v-for="item in dingjiazhuangtai" :key="item.value"
						                   :label="item.label" :value="item.value">
						        </el-option>
						    </el-select>
						</el-form-item>-->
						<el-form-item class="right-btn">
						    <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						    <el-button class="h-btn h-formBtn h-bgwhite" @click="chongzhi">重置</el-button>
						</el-form-item>
					</div>
                    <!-- <div class="h-formBtnOut h-columnCenter">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="chongzhi">重置</el-button>
                    </div> -->
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30 Ju" v-if="clickActive==1">
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    style="width: 100%"
					:border="true"
					max-height="440"
            >
                <el-table-column
                        type="selection"
                        width="40"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="levelname"
                        label="产品大类"
						min-width="150"
						:show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                        prop="materialCode"
                        label="产品编号"
						min-width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="materialDescrition"
                        label="产品型号"
						min-width="300"
						:show-overflow-tooltip="true"
                >
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.materialDescrition}}
						</div>
					</template>
                </el-table-column>
				<el-table-column
						prop="leltypecode"
						label="定价类型"
						min-width="150"
						:show-overflow-tooltip="true"
				>
				</el-table-column>
				<el-table-column
						prop="protype"
						label="型号属性"
						min-width="150"
						:show-overflow-tooltip="true"
				>
				</el-table-column>
				<el-table-column
						prop="type"
						label="级别/区域"
						min-width="150"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						<div v-if="scope.row.leltypecode=='内销'">
							{{scope.row.type | dictname('customer_group')}}
						</div>
						<div v-if="scope.row.leltypecode=='外销'">
							{{scope.row.type | dictname('dj_foreign_area')}}
						</div>
            <div v-if="scope.row.leltypecode=='外贸'">
              {{scope.row.type | dictname('dj_foreign_area')}}
            </div>
					</template>
				</el-table-column>
				<el-table-column
						prop="value"
						label="价格"
						min-width="150"
						:show-overflow-tooltip="true"
				>
				</el-table-column>
				<el-table-column
						prop="currency"
						label="币种"
						min-width="150"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						<div >
							{{scope.row.currency | dictname('YLCurrency')}}
						</div>
					</template>
				</el-table-column>

				<el-table-column
						prop="xiaoe"
						label="是否计入销额"
						width="120"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						{{scope.row.xiaoe | dictname('xiaoe_jishu')}}
					</template>
				</el-table-column>
				<el-table-column
						prop="jishu"
						label="是否计入基数"
						width="120"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						{{scope.row.jishu | dictname('xiaoe_jishu')}}
					</template>
				</el-table-column>
				<el-table-column
						prop="factory"
						label="产地"
						width="60"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						{{scope.row.factory}}
					</template>
				</el-table-column>
				<el-table-column
						prop="marketType"
						width="130"
						label="市场分类">
					<template slot-scope="scope">
						<el-button size="small" type="text" :disabled="!caiwuFlag"
								   @click="clickMarketType(scope.row.materialCode,scope.row.marketType)">
							{{!scope.row.marketType?"空":scope.row.marketType | dictname('market_type')}}
 						</el-button>
					</template>
				</el-table-column>
				<el-table-column
						prop="sceneName"
						width="130"
						label="场景分类">
					<template slot-scope="scope">
						<el-button size="small" type="text" :disabled="!caiwuFlag"
								   @click="clickSceneType(scope.row.materialCode,scope.row.sceneCode,scope.row.sceneName)">
							{{!scope.row.sceneName?"空":scope.row.sceneName }}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column
						prop="productClass"
						label="成品分类"
						min-width="150"
						:show-overflow-tooltip="true"
				>
				</el-table-column>

                <el-table-column
                        prop="setprice"
                        label="定价状态"
						min-width="150"
						:show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="cdates"
                        label="最近一次申请定价时间"
						width="200"
						:show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="210"
                        fixed="right"
                    >
                    <template slot-scope="scope">
                       <div style="text-align: left;">
						   <el-button
						            v-if="scope.row.setpriceastatus==1||scope.row.setpriceastatus==3"
						            type="text"
						            size="small"
						            class="h-tableLink h-btn" @click="todetail(scope.row)">
						        查看
						    </el-button>
						    <el-button
						   								v-if="scope.row.setpriceastatus==2"
						            type="text"
						            size="small"
						            class="h-tableLink h-btn" @click="dingjiaxiugai(scope.row)">
						        修改
						    </el-button>

						    <el-button
						            type="text"
						            size="small"
						            class="h-tableLink h-btn"
									v-auth="'cpgl_faqidingjia'"
									@click="faqidingjia(scope.row)">
						        发起定价
						    </el-button>
               <el-button
                   v-if="scope.row.setpriceastatus==1||scope.row.setpriceastatus==3"
                   type="text"
                   size="small"
                   class="h-tableLink h-btn" @click="historic(scope.row)">
                 历史定价
               </el-button>
					   </div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" v-if="scope.row.setpriceastatus==1||scope.row.setpriceastatus==3" title="查看" @click="todetail(scope.row)"></span>
							<span class="l-operationlist br-operation-xg" v-if="scope.row.setpriceastatus==2" title="修改" @click="dingjiaxiugai(scope.row)"></span>
							<span class="l-operationlist br-operation-fqdj" v-if="scope.row.setpriceastatus!=2" title="发起定价" @click="faqidingjia(scope.row)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>

			<!--修改市场分类弹出框-->
			<el-dialog title="修改市场分类" :visible.sync="dialogVisible"  width="30%">
				<el-form>
					<el-form-item label="市场分类" >
						<brselect category="market_type" v-model="dialog.marketTypeLog" :v="dialog.marketTypeLog"></brselect>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="changeMarketType">确 定</el-button>
				</div>
			</el-dialog>

			<!--修改场景分类弹出框-->
			<el-dialog title="修改市场分类" :visible.sync="dialog2Visible"  width="30%">
				<el-form>
					<el-form-item label="场景分类" class="h-elformWrap-2">
						<el-select v-model="dialog2.sceneCode"  placeholder="请选择" style="width:100%;" @change="getchang"   >
							<el-option v-for="item in sceneList" :key="item.sceneCode"
									   :label="item.sceneName" :value="item.sceneCode">
							</el-option>
						</el-select>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialog2Visible = false">取 消</el-button>
					<el-button type="primary" @click="changeSceneType">确 定</el-button>
				</div>
			</el-dialog>


        <!--汇率列表-->
        <el-dialog title="汇率列表" :visible.sync="caiwuExchangeVisible"  width="70%">
            <div class="l-screenBox">
                <div class="l-retrieval">
                    <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                               @click="createCaiwuExchange()">
                        新增汇率
                    </el-button>
                </div>
            </div>
            <el-table
                ref="multipleTable"
                :data="caiwuExchangeList"
                style="width: 100%"
                :border="true"
                max-height="440"
            >

                <el-table-column
                    fixed
                    type="index"
                    label="#"
                    width="40">
                </el-table-column>
                <el-table-column
                    prop="fromCurrency"
                    label="起始币种"
                    min-width="150"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    prop="toCurrency"
                    label="目标币种"
                    min-width="150"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="exchange"
                    label="汇率"
                    min-width="150"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    prop="cuname"
                    label="创建人名称"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="cdate"
                    :formatter="formatDate"
                    label="创建时间"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="lucode"
                    label="修改人编码"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="ldate"
                    :formatter="formatDate"
                    label="最后修改时间"
                    width="110">
                </el-table-column>

                <el-table-column
                    label="操作"
                    width="110"
                    fixed="right" >

                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn" @click="caiwuExchangeSelectById(scope.row)">
                                修改
                            </el-button>
                            <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn" @click="caiwuExchangeDeleteById(scope.row)">
                                删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>

            </el-table>
        </el-dialog>

        <!--新增修改汇率-->
        <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="caiwuExchangeDetailVisible" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>{{caiwuTitleDig}}</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <el-form ref="form" :model="caiwuExchange" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                        <el-form-item  label="起始币种" class="h-elformWrap-2" label-width="100" prop="fromCurrency" :rules="[{ required: true, message: '请填写起始币种', trigger: 'blur'},]">
                            <el-input v-model="caiwuExchange.fromCurrency" style="width: 84%;"></el-input>
                        </el-form-item>
                        <el-form-item  label="目标币种" class="h-elformWrap-2" label-width="100" prop="toCurrency" :rules="[{ required: true, message: '请填写目标币种', trigger: 'blur'},]">
                            <el-input v-model="caiwuExchange.toCurrency" style="width: 84%;"></el-input>
                        </el-form-item>
                        <el-form-item  label="汇率" class="h-elformWrap-2" label-width="100" prop="exchange" :rules="[{ required: true, message: '请填写汇率', trigger: 'blur'},]">
                            <el-input v-model="caiwuExchange.exchange" type="number" style="width: 84%;"></el-input>
                        </el-form-item>

                    </el-form>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialog">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitCaiwuE()" >提交</el-button>
                     </div>
                </div>
            </el-dialog>



            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"  v-if="adminFlag || this.priceAdmin"
                               style="margin-left:-20px;" @click="outexcel">批量导出
                    </el-button>

                  <!--<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"  v-if="adminFlag"-->
                  <!--            @click="outhistoryexcel">历史定价批量导出-->
                  <!--</el-button>-->

                    <!--                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导入</el-button>-->
                    <el-button
                            class="h-btn h-formBtn h-bgblueQ"
                            icon="h-el-icon h-el-icon-export"
                            @click="uploaddownexcelflagbtn">
                        批量导入
                    </el-button>

                    <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                               v-auth="'cpgl_hlwh'"
                               @click="selectCaiwuExchangeList()">
                        汇率维护
                    </el-button>

                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="el-icon-edit"
                               @click="showBatchModifyDialog">
                        修改型号经理
                    </el-button>



                    <uploaddownexcel
                            :visible.sync="uploaddownexcelflag"
                            v-if="uploaddownexcelflag"
                            clsname="priceImportExcel"
                            :startrow="3"
                            @callback="uploadExcelFilecallback"/>
                </div>

                <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>

        <!-- 批量修改型号经理弹窗组件 -->
        <batch-modify-manager-dialog 
            :visible.sync="batchModifyVisible" 
            @success="query">
        </batch-modify-manager-dialog>

    </div>

</template>
<script>
    import ss from '../../api/SystemService'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    import Treeselect from "@riophae/vue-treeselect";
    import BatchModifyManagerDialog from '@/views/chanp/batchModifyManager/BatchModifyManagerDialog.vue'

    export default {
        components: {
            Treeselect,
            uploaddownexcel,
            BatchModifyManagerDialog,
        },
        name: "productManage",
        data() {
            return {
				sceneList:[],//场景

				dialogVisible:false,
				dialog2Visible:false,
        caiwuExchangeVisible:false,//财务汇率弹窗
        caiwuExchangeDetailVisible:false,//财务回来详情
				dialog:{
					marketTypeLog:'',
					materialCodeLog:'',
				},
				dialog2:{
					sceneCode:'',
					sceneName:'',
					materialCodeLog:'',
				},

                //批量导入
                uploaddownexcelflag: false,
                showOrhide:false,
				status:1,
				checked:true,
				toshow:"priceManage",

                dingjiazhuangtai: [
                 {
                    value: 1,
                    label: '已定价'
                }, {
                    value: 0,
                    label: '未定价'
                }, {
					value: 2,
					label: '暂存'
				}, {
					value: 3,
					label: '提交审核中'
				}],


                wuliaozu: [],

                chanpindalei: [],

                suoyoudingjia: {},

                dingjiashijian: {},


                q: {

                    hid: null,
                    setprice: null,
                    materialGroupCode: null,
                    materialDescrition: null,
                    materialCode:null,
                    priceid: null,
                  chandidata:null,

                    pageSize: 10,
                    pageNo: 1,
                    total: 0,

                },


                //表单
                all: '全部',
                formInline: {
                    dalei: '',
                    status: '',
                    group: '',
                    type: '',
                },
                //表格
                multipleSelection: [],
                tableData2: [],
                caiwuExchangeList: [],
                caiwuExchange:{

                },
                caiwuTitleDig:"",
                clickActive: 1,
				adminFlag:false,
				priceAdmin:false,

				// 批量修改型号经理相关
				batchModifyVisible: false,
            }
        },

        //加载页面默认执行
        created() {
        	//是否有财务权限
			this.caiwuFlag = this.$store.getters.hasRole('swyl_caiwujl');
			//是否管理员权限
			this.adminFlag = this.$store.getters.hasRole('swyl_admin');
			//是否价格管理员
			this.priceAdmin = this.$store.getters.hasRole('swyl_pricegly');

			//默认首次交互
        this.gettableels();
        this.showzhezhao();
        this.query();
      },
      beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
      },
      beforeRouteEnter(to, from, next) {
        to.meta.keepAlive = true;
        next();
      },
        // activated(){
        //     this.query();
        // },
        //监听
        watch: {},


        methods: {
//导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },

            handleCurrentChange() {

            },
            handleSizeChange() {

            },


            //重置
            chongzhi(){

                this.q.hid = '';

                this.q.setprice = '';

                this.q.materialGroupCode = '';

                this.q.materialDescrition = '';

                this.q.materialCode = '';
               this.q.chandidata = null;
            },


            //查询翻页
            query() {

                this.q.idas = [];
                console.log(this.q, '看看都有啥')

                ss.chanpin.havmarselectPage(this.q).then(rd => {

                    this.tableData2 = [],

                        this.q.total = rd.total;

                    console.log(rd.records,'看看多少')

                    for (var t in rd.records) {

                        console.log(rd.records[t]);


                        var ss = {

                            levelname: rd.records[t].levelname==null?"空":rd.records[t].levelname,//产品大类
                            groupname: rd.records[t].groupname==null?"空":rd.records[t].groupname,//物料组名
                            materialGroupCode: rd.records[t].materialGroupCode,//物料组
                            materialDescrition: rd.records[t].materialDescrition,//物料型号
                            oemType: rd.records[t].oemType,//业务类型  SH或者HK。SH为上海OEM，HK为香港OEM    ****只有从我们这里保存的产品才有****
                            hid: rd.records[t].hid,
                            rowId: rd.records[t].rowId,//mdm取数的表的主键
                            setprice: rd.records[t].setprice==null?'mdm物料':rd.records[t].setprice == 0 ? '未定价' :rd.records[t].setprice == 1 ? '已定价':rd.records[t].setprice == 2 ?'暂存':rd.records[t].setprice == 3 ?'提交审核中':'',
                            cdate: rd.records[t].cdate,//虚拟物料创建时间
                            materialCode: rd.records[t].materialCode,//产品编号id
                            priceid: rd.records[t].priceid,//定价 id
							setpriceastatus: rd.records[t].setprice==null?1:rd.records[t].setprice,
                            cdates: rd.records[t].zuihoudingjia == null || rd.records[t].zuihoudingjia == '' ? '' : this.$util.riQi(rd.records[t].zuihoudingjia),//最后定价时间
                            typeUserCode: rd.records[t].typeUserCode,
                            protype: rd.records[t].protype,
							leltypecode: rd.records[t].leltypecode=='0'?"外销":rd.records[t].leltypecode=='2'?"外贸":"内销",
							type: rd.records[t].type,
							value: rd.records[t].value,
							currency: rd.records[t].currency,
							serviceProductsType: rd.records[t].serviceProductsType,
                            gross: rd.records[t].gross,
                            cost: rd.records[t].cost,
                            unitPrice: rd.records[t].unitPrice,
                            unitSellingPrice: rd.records[t].unitSellingPrice,
							xiaoe: rd.records[t].xiaoe,//是否计入销额
							jishu: rd.records[t].jishu,//是否计入基数
							factory: rd.records[t].factory,//工厂
							marketType: rd.records[t].marketType,//市场分类
							sceneCode: rd.records[t].sceneCode, //场景分类编码
							sceneName: rd.records[t].sceneName,//场景分类名称
							productClass: rd.records[t].productClass,//成品类别

						}
                        this.tableData2.push(ss);

                    }

                });
                //加载所有场景类型
				ss.bom.getAllSceneList().then(rd => {
					this.sceneList = rd.msg;
				});
            },


            //加载配置项
            gettableels() {

                this.query();

            },


            handleFilter() {
                this.q.pageNo = 1;
                this.query();
            },


            handleSelectionChange(val) {

                console.log(val)
                this.multipleSelection = val;
            },


            //导表
            outexcel() {
                if(this.multipleSelection.length>0){
                    var model = [];
                    for (var d in this.multipleSelection) {
                        model.push(
                            {
                                materialid:this.multipleSelection[d].materialCode
                            }
                        )
                    }
                    ss.chanpin.downloadExcelbymodel(model);
                }else{
                    ss.chanpin.downloadExcelbyq(this.q);
                }
            },

          //历史定价批量导出
          outhistoryexcel() {
            if(this.multipleSelection.length>0){
              var model = [];
              for (var d in this.multipleSelection) {
                model.push({
                  materialid:this.multipleSelection[d].materialCode,
                  id:this.multipleSelection[d].priceid
                })
              }
              ss.chanpin.downloadExcelhistorybymodel(model);
            }else{
              ss.chanpin.downloadExcelhistorybyq(this.q);
            }
          },



			//修改定价
            dingjiaxiugai(q) {
                if(q.materialCode){
				    this.$router.push({path: '/chanp/priceChange',query:q});
                }else{
                    this.$msg.msge('数据错误，缺少必要的物料号')
                }
            },
			//发起定价
            faqidingjia(q) {
				if(q.materialCode){
					this.$router.push({path: '/chanp/priceChange',query:q});
				}else{
					this.$msg.msge('数据错误，缺少必要的物料号')
				}
            },
			//查看详情
			todetail(q) {
          if(q.materialCode){
              this.$router.push({path: '/chanp/priceOnlyRead',query:q});
          }else{
              this.$msg.msge('数据错误，缺少必要的物料号')
          }
      },
      //历史定价
       historic(q) {
        if(q.materialCode){
          this.$router.push({path: '/chanp/priceHistoric',query:q});
        }else{
          this.$msg.msge('数据错误，缺少必要的物料号')
        }
      },
      closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },

            nextStep(i){
				if(this.status ==1){
					this.status = 2;
                }else if(this.status ==2){
					this.status = 3;
				}else if(this.status ==3){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			},
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
			//点击市场分类弹出
			clickMarketType(materialCode,marketType){
				this.dialogVisible = true;
				this.dialog.marketTypeLog = marketType;
				this.dialog.materialCodeLog = materialCode;
			},
			//点击场景分类弹出
			clickSceneType(materialCode,sceneCode,sceneNmae){
 				this.dialog2Visible = true;
				this.dialog2.sceneCode = sceneCode
				this.dialog2.sceneName = sceneNmae;
				this.dialog2.materialCodeLog = materialCode;
 			},

			//修改市场分类
			changeMarketType(){
				this.$confirm("确认修改"+this.dialog.materialCodeLog+"市场分类？", '提示')
						.then(_ => {
							this.dialogVisible = false;
							ss.chanpin.changeMarketType(this.dialog.materialCodeLog,this.dialog.marketTypeLog).then(rd => {
								this.query();
								this.$message({
									type: "success",
									message: rd.msg
								});
							})
						})
						.catch(_ => {
						})

			},
			//修改场景分类
			changeSceneType(){
 				this.$confirm("确认修改"+this.dialog2.materialCodeLog+"市场分类？", '提示')
						.then(_ => {
							this.dialog2Visible = false;
							ss.chanpin.changeSceneType(this.dialog2.materialCodeLog,this.dialog2.sceneCode,this.dialog2.sceneName).then(rd => {
								this.query();
								this.$message({
									type: "success",
									message: rd.msg
								});
							})
						})
						.catch(_ => {
						})

			},
			getchang(code) {
				this.dialog2.sceneCode = code;
				const scene = _.find(this.sceneList,{sceneCode:code})
				this.dialog2.sceneName =  scene.sceneName;

			},

       /**********************财务汇率列表模块************************8***/
        selectCaiwuExchangeList(){
            this.caiwuExchangeVisible = true
            this.getCaiwuExchangeList();
        },
        //查询列表
        getCaiwuExchangeList(){
            ss.chanpin.getCaiwuExchangeList().then(rd => {
                this.caiwuExchangeList = rd.obj;
            })

        },
        /*根据id查询财务汇率*/
       caiwuExchangeSelectById(q){
            ss.chanpin.caiwuExchangeSelectById(q.id).then(rd => {
                this.caiwuExchange = rd.obj;
                this.caiwuExchangeDetailVisible =true;
                this.caiwuTitleDig = "修改汇率"

            })
       },
        /*新增汇率*/
        createCaiwuExchange(q){
            this.caiwuTitleDig = "新增汇率"
            this.caiwuExchangeDetailVisible =true;
        },
        //根据id删除
        caiwuExchangeDeleteById(q){
            this.$msg.confirm("确认删除？",()=>{
                ss.chanpin.caiwuExchangeDeleteById(q.id).then(rd => {
                    this.$msg.msgs("删除成功！");
                    this.getCaiwuExchangeList();
                })
            })
        },

        //关闭弹窗,清空数据
        closeDialog(){
            this.caiwuExchangeDetailVisible = false
            this.caiwuExchange ={};
        },
        //新增或修改汇率
        submitCaiwuE(q){
            ss.chanpin.caiwuExchangeSaveOrUpdate(this.caiwuExchange).then(rd => {
                this.$msg.msgs("提交成功！");
                this.caiwuExchangeDetailVisible =false;
                this.getCaiwuExchangeList();
            })
        },
        /*****************************财务汇率列表模块***************/
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property]
            if(data == null || data == '') {
                return null
            }
            let dt = new Date(data)
            return this.$util.riQi3(dt);
        },

        // 显示批量修改弹窗
        showBatchModifyDialog() {
            this.batchModifyVisible = true
        },

        },

        mounted() {
			// this.status = sessionStorage.priceManage?sessionStorage.priceManage:1;
			// if(sessionStorage.priceManage != 2){
			// 	this.showOrhide = true;
			// }
        },
    }
</script>
<style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }
</style>
<style>
.Ju .h-btn.el-button.h-tableLink{
    padding: 0 0.05rem;
}

</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top:0;
			left:0;
		}
		.step2{
			top:0;
			left:0;
		}
		.step3{
			top:0;
			left:0;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>


